import { TranslationService } from '@raptor-fe/services';

/**
 * Translates a message delivery-status name (the backend lifecycle value: Created, Queued, Submitted,
 * Delivered, Received, Read, Failed) to the viewer's locale. The status arrives from the API as an English
 * identifier; rendering it raw leaves it English for en-AU. Literal case labels keep the translation extractor
 * able to discover the keys; an unknown status falls back to the raw value so a new backend status still shows.
 */
export function translateCustomerTextStatus(name: string | null | undefined, translationService: TranslationService): string {
    if (!name) {
        return '';
    }

    const feature = 'Customer Messaging';
    const component = 'Message Status';

    switch (name) {
        case 'Created':
            return translationService.getTranslation(feature, component, 'Created');
        case 'Queued':
            return translationService.getTranslation(feature, component, 'Queued');
        case 'Submitted':
            return translationService.getTranslation(feature, component, 'Submitted');
        case 'Delivered':
            return translationService.getTranslation(feature, component, 'Delivered');
        case 'Received':
            return translationService.getTranslation(feature, component, 'Received');
        case 'Read':
            return translationService.getTranslation(feature, component, 'Read');
        case 'Failed':
            return translationService.getTranslation(feature, component, 'Failed');
        default:
            return name;
    }
}
